module.exports = __webpack_public_path__ + "img/fBlWwoiF.140ab50d.svg";